import { Web2PublishWelcome } from 'components/Web2Publish/components/Welcome';

const ScreenWeb2PublishWelcome = () => {
  return <Web2PublishWelcome />;
};

export default ScreenWeb2PublishWelcome;
